import {Service} from "@/services/Service";

export class ExtService extends Service {
    constructor(axios) {
        super(axios, "");
        // this.fields = [
        //     "username": this.$localStorageService.,
        //     "password": "",
        // ]
    }

    obtenerIP() {
        this.onStart();
        return this.http.get("https://api.ipify.org?format=json")
            .then((response) => response)
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}